import{jsx as l,jsxs as p}from"react/jsx-runtime";import{Children as d}from"react";import t from"styled-components";import{mq as s}from"../../shared/media-queries.js";import e from"../../theme.js";const h=t.div`
  ${s("mobileS","tablet")} {
    display: block;
    max-width: -moz-fit-content;
    max-width: fit-content;
    margin: 0 auto;
    overflow-x: auto;
    white-space: nowrap;
  }
`,g=t.table`
  border-collapse: collapse;
  border: 1px solid ${e.colors.grayscaleToned.light3};
  font-family: ${e.typography.fontBaseFamily};
  text-align: left;
`,f=t.thead``,y=t.th`
  border: 1px solid ${e.colors.grayscaleToned.light3};
  padding: 0.75rem;
  vertical-align: top;
  background-color: ${e.colors.background.gray};
`,b=t.tbody``,c=t.tr``,n=t.td`
  border: 1px solid ${e.colors.grayscaleToned.light3};
  padding: 0.5rem 0.75rem;
  vertical-align: top;
`,x=r=>l(c,{children:d.toArray(r.map((o,a)=>l(y,{scope:"col",children:o},a)))},"RowHead"),u=(r,o)=>o.length?r.map(a=>o?.map(i=>l(n,{children:a[i]},i))):r.map(a=>Object.entries(a).map(([i,m])=>l(n,{children:m},i))),w=r=>d.toArray(r.map((o,a)=>l(c,{children:d.toArray(o)},a))),$=({columns:r,data:o,ariaLabel:a})=>l(h,{children:p(g,{"aria-label":a,children:[r&&l(f,{children:x(r)}),o&&l(b,{children:w(u(o,r??[]))})]})});export{$ as default};
